<template>
  <section>
    <form method="post" @submit.prevent="send" novalidate>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ formTitle }}
          </p>
        </header>
        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group horizontal name="name" :label="$t('attributes.name')">
              <b-input
                v-model="form.name"
                name="name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.name')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="area_code"
              attribute="attributes.area"
              :label="$t('attributes.area')"
            >
              <b-select
                v-model="selectedArea"
                name="area_code"
                :loading="isLoading"
                :placeholder="
                  $t('message.please_select') + $t('attributes.area')
                "
                expanded
                @input="onSelectArea"
              >
                <option value="" disabled>
                  {{ $t('message.please_select') + $t('attributes.area') }}
                </option>
                <option
                  v-for="option in areas"
                  :key="option.code"
                  :value="option"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </form-group>

            <form-group
              horizontal
              name="country_id"
              attribute="attributes.country"
              :label="$t('attributes.country')"
            >
              <b-select
                v-model="selectedCountry"
                name="country_id"
                :loading="isLoading"
                :placeholder="
                  $t('message.please_select') + $t('attributes.country')
                "
                expanded
                @input="onSelectCountry"
              >
                <option value="" disabled>
                  {{ $t('message.please_select') + $t('attributes.country') }}
                </option>
                <option
                  v-for="option in countries"
                  :key="option.id"
                  :value="option"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </form-group>
          </form-wrapper>
        </section>

        <footer class="modal-card-foot">
          <b-button :loading="isSending" @click="$parent.close()">
            {{ $t('attributes.cancel') }}
          </b-button>
          <b-button
            :loading="isSending || isLoading"
            type="is-primary"
            native-type="submit"
          >
            {{ region.id ? $t('attributes.update') : $t('attributes.add') }}
          </b-button>
        </footer>

        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
      </div>
    </form>
  </section>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { AREA_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'RegionForm',

  props: {
    isSending: {
      type: Boolean,
      default: false
    },
    region: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isLoadingArea: false,
      areas: [],
      selectedArea: null,

      isLoadingCountry: false,
      countries: [],
      selectedCountry: null,

      form: {
        id: this.region.id,
        area_code: this.region.area_code && this.region.area_code.trim(),
        country_id: this.region.country_id,
        name: this.region.name && this.region.name.trim()
      }
    }
  },
  computed: {
    formTitle() {
      let title = this.region.id
        ? this.$t('attributes.modify')
        : this.$t('attributes.add')

      title += this.$t('attributes.region')

      return title
    },
    isLoading() {
      return this.isLoadingArea || this.isLoadingCountry
    }
  },
  validations: {
    form: {
      area_code: { required },
      country_id: { required },
      name: { required }
    }
  },
  mounted() {
    this.loadAreas()
  },
  methods: {
    async loadAreas() {
      try {
        this.isLoadingArea = true
        const res = await this.axios.get(AREA_API)
        const areas = res.data.data
        this.areas = areas.sort(a => a.sort)

        if (this.form.area_code) {
          this.selectedArea = this.areas.find(
            a => a.code === this.form.area_code
          )
          this.form.area_code = this.selectedArea && this.selectedArea.code
        }

        if (this.selectedArea) {
          await this.loadCountries()
        }
      } catch (e) {
        this.areas = []
        this.selectedArea = null

        notifyService.fetch_error('area', e)
      } finally {
        this.isLoadingArea = false
      }
    },
    async loadCountries() {
      try {
        const api = `${AREA_API}/${this.form.area_code}/countries`

        this.isLoadingCountry = true
        const res = await this.axios.get(api)
        this.countries = res.data.data

        if (this.form.country_id) {
          this.selectedCountry = this.countries.find(
            a => a.id === this.form.country_id
          )
          this.form.country_id = this.selectedCountry && this.selectedCountry.id
        }
      } catch (e) {
        this.countries = []
        this.selectedCountry = null

        notifyService.fetch_error('country', e)
      } finally {
        this.isLoadingCountry = false
      }
    },
    onSelectArea(option) {
      this.form.area_code = option && option.code
      this.loadCountries()
    },
    onSelectCountry(option) {
      this.form.country_id = option && option.id
    },
    send() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
